/**
 * Brand configuration — single source of truth for all rename-sensitive values.
 * Change values here. Rebuild. Done.
 */
export const brand = {
  appName: 'frontdesk',
  appSlug: 'frontdesk',
  logoUrl: '/logo.svg',
  faviconUrl: '/favicon.ico',
  supportEmail: 'support@frontdesk.app',
  marketingUrl: 'https://frontdesk.app',
  primaryColor: '#2563EB',
  defaultLocale: 'en-US',
  defaultTimezone: 'America/New_York',
  poweredByText: 'Powered by frontdesk',
} as const;

export type Brand = typeof brand;
